module.exports = __webpack_public_path__ + "img/stock7.eb09074e.png";